import * as React from "react";
import { UserSearchInput } from "./UserSearchInput";
import { TestIds } from "../testIds";

type CollaboratorConfirmation = "CONFIRMED" | "PENDING" | "UNASKED";

export const CollaboratorsInput = ({
  values,
  onChange,
  confirmations,
}: {
  values: string[];
  onChange: (values: string[]) => void;
  confirmations?: CollaboratorConfirmation[];
}) => {
  return (
    <div>
      <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300">
        Collaborators (optional)
      </label>
      <div className="space-y-2">
        {[0, 1, 2, 3, 4, 5].map((x) => (
          <div key={x} className="flex items-center gap-3">
            <UserSearchInput
              defaultValue={values[x] || ""}
              placeholder={`collaborator #${x + 1}`}
              testId={`${TestIds.CollaboratorInput}-${x}`}
              onValueChange={(value) => {
                const newValues = [...values];
                newValues[x] = value;
                onChange(newValues);
              }}
            />

            {confirmations && (
              <div className="w-32">
                {(() => {
                  switch (confirmations[x]) {
                    case "CONFIRMED":
                      return (
                        <span
                          className="inline-flex items-center gap-2 text-green-600 dark:text-green-400"
                          data-testid={TestIds.CollaboratorConfirmed}
                        >
                          <i className="fa fa-check" aria-hidden="true"></i>
                          <span className="text-sm font-medium">Confirmed</span>
                        </span>
                      );
                    case "PENDING":
                      return (
                        <span
                          className="inline-flex items-center gap-2 text-amber-600 dark:text-amber-400"
                          data-testid={TestIds.CollaboratorPending}
                        >
                          <i
                            className="fa fa-spinner fa-pulse"
                            aria-hidden="true"
                          ></i>
                          <span className="text-sm font-medium">Pending</span>
                        </span>
                      );
                    case "UNASKED":
                      return null;
                  }
                })()}
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
        Enter usernames of collaborators. They'll receive a request to confirm.
      </p>
    </div>
  );
};
